






























































































import Vue from "vue"
import { Office } from "@/model/entity/office/office"
import { ElForm } from "element-ui/types/form"
import _ from "lodash"

export default Vue.extend({
  data() {
    return {
      requiredEmail: true,
      requiredTel: true,
      rules: {
        officeName: [
          {
            required: true,
            message: this.$t("user_administration.office.name_validation"),
            trigger: "change"
          },
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: "change"
          }
        ],
        senderId: [
          {
            required: true,
            message: this.$t("entity.office.error.sender_id"),
            trigger: ["change", "blur"]
          },
          {
            max: 17,
            message: `${this.$t("user_administration.max")} 17 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          }
        ],
        officeStreet: [
          {
            required: true,
            message: this.$t("user_administration.office.street_validation"),
            trigger: "change"
          },
          {
            max: 50,
            message: `${this.$t("user_administration.max")} 50 ${this.$t("user_administration.chars")}`,
            trigger: "change"
          }
        ],
        officeHouseNumber: [
          {
            max: 8,
            message: `${this.$t("user_administration.max")} 8 ${this.$t("user_administration.chars")}`,
            trigger: "change"
          }
        ],
        officeCity: [
          {
            required: true,
            message: this.$t("user_administration.office.city_validation"),
            trigger: "change"
          },
          {
            max: 50,
            message: `${this.$t("user_administration.max")} 50 ${this.$t("user_administration.chars")}`,
            trigger: "change"
          }
        ],
        officeZip: [
          {
            required: true,
            message: this.$t("user_administration.office.zip_validation"),
            trigger: "change"
          },
          {
            max: 7,
            message: `${this.$t("user_administration.max")} 7 ${this.$t("user_administration.chars")}`,
            trigger: "change"
          }
        ],
        officeTel: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: "change"
          },
          {
            validator: (rule: any, value: string, callback: (err?: Error) => void) => {
              if (value && !new RegExp(/^[(]?[+]?[0-9 \-\/()]+$/).test(value)) {
                callback(new Error(`${this.$t("user_administration.invalid_format.phone")}`))
              }
              callback()
            },
            trigger: "change"
          },
          {
            validator: (rule: any, value: any, callback: any) => {
              const vm = this as any
              if (value === "" && vm.office.officeEmail === "") {
                callback(new Error(`${this.$t("user_administration.predict.email_or_telephone")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          }
        ],
        officeContactPerson: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: "change"
          }
        ],
        officeEmail: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: "change"
          },
          {
            validator: (rule: any, value: any, callback: any) => {
              const vm = this as any
              if (value === "" && vm.office.officeTel === "") {
                callback(new Error(`${this.$t("user_administration.predict.email_or_telephone")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          }
        ]
      }
    }
  },
  props: {
    office: {
      type: Object as () => Office,
      required: true
    },
    formValid: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    validateForm() {
      const form = this.$refs["form"] as ElForm
      let validationResult = false
      if (!!form) {
        form.validate(valid => {
          validationResult = valid
        })
      }
      this.$emit("update:formValid", validationResult && this.validEmail)
    },
    fuzzySearchCity(input: string, callback: any) {
      if (input && input.length >= 3) {
        this.$http
          .get("cities/fuzzy/cities?country_code=" + this.office.country.isoCodeAlpha2 + "&city=" + input)
          .then(response => {
            callback(response.data)
          })
      } else {
        callback([])
      }
    },
    fuzzySearchZipcode(input: string, callback: any) {
      if (input && input.length >= 3) {
        this.$http
          .get("cities/fuzzy/zipcodes?country_code=" + this.office.country.isoCodeAlpha2 + "&zipcode=" + input)
          .then(response => {
            callback(response.data)
          })
      } else {
        callback([])
      }
    },
    setCityAndZipcode(entity: any) {
      this.office.officeCity = entity.name
      this.office.officeZip = entity.postalCode
    }
  },
  computed: {
    validEmail(): boolean {
      if (exists(this.office) && notEmpty(this.office.officeEmail)) {
        // tslint:disable-next-line
        return new RegExp(
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
        ).test(this.office.officeEmail!!)
      }
      return true
    }
  },
  watch: {
    office: {
      deep: true,
      handler() {
        if (!this.office.officeEmail && !this.office.officeTel) {
          this.requiredEmail = true
          this.requiredTel = true
        }
        if (this.office.officeTel && !this.office.officeEmail) {
          this.requiredEmail = false
          this.requiredTel = true
        }
        if (this.office.officeEmail && !this.office.officeTel) {
          this.requiredEmail = true
          this.requiredTel = false
        }
        this.validateForm()
      }
    }
  },
  mounted() {
    this.validateForm()
  },
  created() {
    this.office.senderId = this.office.senderId.toString()
  }
})
